import { MessageSquareOff } from "lucide-react";
import PageContainer from "@/pages/containers/page-container";

interface Props {
  message?: string;
}

const DEFAULT_MESSAGE =
  "Chat message history is not visible in CSR preview mode. Only the member can access their conversations.";

export const ChatNotAvailable = ({ message = DEFAULT_MESSAGE }: Props) => {
  return (
    <PageContainer title="Chats">
      <div className="flex h-full select-none flex-col items-center justify-center gap-4 text-gray-400">
        <div className="rounded-full bg-gray-100 p-4">
          <MessageSquareOff className="size-10 text-gray-400" />
        </div>
        <div className="flex flex-col items-center gap-1.5">
          <p className="text-sm font-semibold text-gray-600">
            Chat Not Available
          </p>
          <p className="max-w-xs px-4 text-center text-xs leading-relaxed">
            {message}
          </p>
        </div>
      </div>
    </PageContainer>
  );
};
